import React, {useState} from 'react';
import styled from 'styled-components';
import {CONSTS}  from './_constants';
// import {Link} from 'react-router-dom';
import Link from './link';
import Icon from './icon';

const NavItem = ({children, icon, href=null, to=null, onClick=null}) => {
    const path = to ? to : href;
    const active = path === window.location.pathname;
    const content = <>
                        {icon && <Icon className='_icon' icon={icon}/>}
                        <span className="_label">{children}</span>
                    </>
    return(
        <li className={active ? "active" : ""} onClick={onClick}>
            {(to || href) ? <Link to={to} href={href}>
                {content}
            </Link> : content}
        </li>
    )
}
const Nav = ({className, children}) => (
    <StyledNav className={className}>
        <ul>
            {children}
        </ul>
    </StyledNav>
)
Nav.Item  = NavItem;

const StyledNav = styled.div`
    > ul {
        list-style-type: none;
        padding-left: 30px;
        li{
            margin: 20px 0;
            cursor: pointer;
            &:hover{
                ._label, ._icon{
                    color:#666;
                }    
            }
            a{
                text-decoration: none;
                display: block;
            }
            ._label, ._icon{
                font-size: 15px;
                color: rgba(211, 212, 218, 1);
                font-weight: 600;
                transition: color .2s;
                
            }
            ._label{
                margin-left: 14px;
            }
            &.active{
                ._label, ._icon{
                    color: ${CONSTS.colors.primary}
                }
            }
        }
    }
`

export default Nav;